import type { FC } from "react";
import { Button } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Link as RouterLink } from "react-router-dom";

interface CreateButtonProps {
	route: string;
	label: string;
	disabled?: boolean;
	"data-testid"?: string;
}

const CreateButton: FC<CreateButtonProps> = (props) => {
	const { route, label, disabled } = props;

	return (
		<Button
			color="primary"
			startIcon={<AddCircleIcon />}
			variant="contained"
			sx={{ ml: 2 }}
			component={RouterLink}
			to={route}
			disabled={disabled ?? false}
			data-testid={props["data-testid"]}
		>
			{label}
		</Button>
	);
};

export default CreateButton;
